import React from "react";

type Props = {
  className: any;
};

const Logo: React.FC<Props> = ({ className }) => {
  const href = `https://zevi.ai/?utm_source=${window.location.hostname}&utm_medium=SearchPage`;

  return (
    <div>
      <a href={href} target="_blank" rel="noreferrer">
        <div>
          <img
            src="https://static.zevi.ai/resources/logo-72x38.webp"
            className={className}
            alt="Zevi logo"
          />
        </div>
      </a>
    </div>
  );
};

export default Logo;
